module.exports = __webpack_public_path__ + "static/media/art34.47cf3a4c.jpg";